import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BsChevronDown } from 'react-icons/bs';
import { HiOutlineQuestionMarkCircle } from 'react-icons/hi2';

const faqs = [
  {
    q: 'What boards and subjects does ZenQB cover?',
    a: 'ZenQB covers CBSE, ICSE, IGCSE, IB, and state boards for school (Class 6–12), plus engineering semesters 1–8 across all major branches. We cover Math, Science, Physics, Chemistry, Biology, Computer Science, and more.',
  },
  {
    q: 'How does the AI Tutor work?',
    a: 'Our AI Tutor uses advanced language models fine-tuned for Indian education. Ask any question and receive step-by-step explanations tailored to your syllabus. It understands board-specific marking schemes and exam patterns.',
  },
  {
    q: 'Is there a free plan available?',
    a: 'Yes! The free plan gives you 5 AI explanations per day, access to the school question bank, and basic progress tracking. No credit card required to start.',
  },
  {
    q: 'Can I use ZenQB on my phone?',
    a: 'Absolutely. ZenQB is fully responsive and works great on phones, tablets, and desktops. No app download needed — just open your browser and start practicing.',
  },
  {
    q: 'How are mock exams different from regular practice?',
    a: 'Mock exams simulate real board exam conditions with timed sessions, proper mark distributions, and mixed question types. After completion, you get a detailed analysis of your performance, time management, and topic-wise breakdown.',
  },
];

function FAQItem({ faq, isOpen, toggle }) {
  return (
    <div className="glass rounded-2xl overflow-hidden hover:bg-white/[0.06] transition-all duration-300">
      <button
        onClick={toggle}
        className="w-full flex items-center justify-between p-6 text-left"
      >
        <span className="font-semibold text-white pr-4">{faq.q}</span>
        <BsChevronDown
          className={`flex-shrink-0 text-gray-400 transition-transform duration-300 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div className="px-6 pb-6 text-sm text-gray-400 leading-relaxed">
              {faq.a}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="section-padding relative">
      <div className="container-custom mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 glass rounded-full px-4 py-2 mb-6">
            <HiOutlineQuestionMarkCircle className="text-brand-400" />
            <span className="text-sm font-medium text-gray-300">FAQ</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold font-display text-white mb-4">
            Got <span className="gradient-text">questions?</span>
          </h2>
          <p className="text-gray-400 text-lg">Everything you need to know about ZenQB.</p>
        </motion.div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05, duration: 0.4 }}
            >
              <FAQItem
                faq={faq}
                isOpen={openIndex === i}
                toggle={() => setOpenIndex(openIndex === i ? -1 : i)}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
